import router from '@/router'
import menuUtils from '@/assets/js/menuUtils.js'
// import i18n from '../../i18n'
// import Main from '@/components/main/Main.vue'

const state = {
  menuRouters: [],
  menuLists: []
}
const getters = {
  getMenuRouters (state) {
    return state.menuRouters
  },
  getMenuLists (state) {
    return state.menuLists
  }
}
const mutations = {
  setMenuRouters (state, menuRouters) {
    state.menuRouters = menuRouters
  },
  setMenuLists (state, menuLists) {
    state.menuLists = menuLists
  }
}
const actions = {
  addMenuRouters ({ commit }, menuRouters) {
    commit('setMenuRouters', menuRouters)
    router.$addRoutes(menuRouters)
  },
  getAsyncRoutes ({ commit }) {
    const dyanmicRouters = window.sessionStorage.getItem('dyanmicRouters')
    const localRouters = JSON.parse(dyanmicRouters)
    const rts = menuUtils.getLocalRouters(localRouters)
    commit('setMenuRouters', rts)
    router.$addRoutes(rts)
    // const result = []
    // result.push({
    //   path: '/main',
    //   name: 'Main',
    //   component: Main,
    //   children: children,
    //   meta: {
    //     title: i18n.t('users.login.title')
    //   }
    // })
    // if (result) {
    //   commit('setMenuRouters', result)
    //   router.$addRoutes(result)
    // }
  }
}
export default {
  namespaced: true,
  getters,
  mutations,
  actions,
  state
}
